export const ONE_DRIVE_PRO = 'OneDrivePro';

export const enum OwaSharingAudience {
    specificPeople = 0,
    organization = 1,
    anyone = 2,
    existing = 3,
    specificPeopleFlex = 4,
    customLabeledSpecificPeople = 5,
}
